import SuperFetch from 'library/helpers/superFetch';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import { typesActions } from './slice';

// Generic fetch function to avoid repetition
function* fetchData(apiEndpoint, successAction, errorAction) {
	try {
		const res = yield call(() => SuperFetch.get(apiEndpoint));
		if (res.statusCode === 200) {
			const data = res.data.filter ? res.data.filter((item) => !item.deletedDate) : res.data;
			yield put(successAction(data));
		} else {
			throw new Error(res.message);
		}
	} catch (error) {
		yield put(errorAction());
	}
}

function* loadContactTypes() {
	yield fetchData('/misc/contactType', typesActions.loadContactTypesSuccess, typesActions.loadContactTypesError);
}

function* loadAddressTypes() {
	yield fetchData('/misc/addressType', typesActions.loadAddressTypesSuccess, typesActions.loadAddressTypesError);
}

function* loadAdminTypes() {
	yield fetchData('/misc/adminType', typesActions.loadAdminTypesSuccess, typesActions.loadAdminTypesError);
}

function* loadCategoryTypes() {
	yield fetchData('/misc/categoryTypes', typesActions.loadCategoryTypesSuccess, typesActions.loadCategoryTypesError);
}

function* loadFieldTypes() {
	yield fetchData('/misc/categoryFieldType', typesActions.loadFieldTypesSuccess, typesActions.loadFieldTypesError);
}

function* loadBookingTypes() {
	yield fetchData('/misc/bookingType', typesActions.loadBookingTypesSuccess, typesActions.loadBookingTypesError);
}

function* loadEntityTypes() {
	yield fetchData('/misc/entityType', typesActions.loadEntityTypesSuccess, typesActions.loadEntityTypesError);
}

function* loadMaintenanceTypes() {
	yield fetchData(
		'/misc/maintenanceTypes',
		typesActions.loadMaintenanceTypesSuccess,
		typesActions.loadMaintenanceTypesError
	);
}

function* loadRoleList() {
	yield fetchData('/misc/rolesList', typesActions.loadRoleListSuccess, typesActions.loadRoleListError);
}

function* loadUserTypes() {
	yield fetchData('/misc/userTypes', typesActions.loadUserTypesSuccess, typesActions.loadUserTypesError);
}

function* loadCredentialTypes() {
	yield fetchData(
		'/misc/credentialTypes',
		typesActions.loadCredentialTypesSuccess,
		typesActions.loadCredentialTypesError
	);
}

function* loadCardTemplatesTypes() {
	yield fetchData(
		'/credentials/templates',
		typesActions.loadCardTemplatesTypesSuccess,
		typesActions.loadCardTemplatesTypesError
	);
}

function* loadDeviceGroupsTypes() {
	yield fetchData(
		'/misc/deviceGroupsTypes',
		typesActions.loadDeviceGroupsTypesSuccess,
		typesActions.loadDeviceGroupsTypesError
	);
}

// Load all types in parallel and dispatch success or error action
function* loadAllTypes() {
	// get state of all types.

	const {
		loadContactTypesComplete,
		loadAddressTypesComplete,
		loadAdminTypesComplete,
		loadCategoryTypesComplete,
		loadFieldTypesComplete,
		loadBookingTypesComplete,
		loadEntityTypesComplete,
		loadMaintenanceTypesComplete,
		loadRoleListComplete,
		loadUserTypesComplete,
		loadCredentialTypesComplete,
		loadCardTemplatesTypesComplete,
		cardTemplatesTypes,
		loadDeviceGroupsTypesComplete
	} = yield select((state) => state.Types);

	if (!loadContactTypesComplete) yield put(typesActions.loadContactTypes());
	if (!loadAddressTypesComplete) yield put(typesActions.loadAddressTypes());
	if (!loadAdminTypesComplete) yield put(typesActions.loadAdminTypes());
	if (!loadCategoryTypesComplete) yield put(typesActions.loadCategoryTypes());
	if (!loadFieldTypesComplete) yield put(typesActions.loadFieldTypes());
	if (!loadBookingTypesComplete) yield put(typesActions.loadBookingTypes());
	if (!loadEntityTypesComplete) yield put(typesActions.loadEntityTypes());
	if (!loadMaintenanceTypesComplete) yield put(typesActions.loadMaintenanceTypes());
	if (!loadRoleListComplete) yield put(typesActions.loadRoleList());
	if (!loadUserTypesComplete) yield put(typesActions.loadUserTypes());
	if (!loadCredentialTypesComplete) yield put(typesActions.loadCredentialTypes());
	if (!loadCardTemplatesTypesComplete || cardTemplatesTypes.length === 0) {
		yield put(typesActions.loadCardTemplatesTypes());
	}
	if (!loadDeviceGroupsTypesComplete) yield put(typesActions.loadDeviceGroupsTypes());
}

// Root saga to watch for all actions
export default function* rootSaga() {
	yield takeLatest(typesActions.loadContactTypes, loadContactTypes);
	yield takeLatest(typesActions.loadAddressTypes, loadAddressTypes);
	yield takeLatest(typesActions.loadAdminTypes, loadAdminTypes);
	yield takeLatest(typesActions.loadCategoryTypes, loadCategoryTypes);
	yield takeLatest(typesActions.loadFieldTypes, loadFieldTypes);
	yield takeLatest(typesActions.loadBookingTypes, loadBookingTypes);
	yield takeLatest(typesActions.loadEntityTypes, loadEntityTypes);
	yield takeLatest(typesActions.loadMaintenanceTypes, loadMaintenanceTypes);
	yield takeLatest(typesActions.loadRoleList, loadRoleList);
	yield takeLatest(typesActions.loadAllTypes, loadAllTypes);
	yield takeLatest(typesActions.loadUserTypes, loadUserTypes);
	yield takeLatest(typesActions.loadCredentialTypes, loadCredentialTypes);
	yield takeLatest(typesActions.loadCardTemplatesTypes, loadCardTemplatesTypes);
	yield takeLatest(typesActions.loadDeviceGroupsTypes, loadDeviceGroupsTypes);
}
